module.exports = __webpack_public_path__ + "static/media/logo-pango.cb2d70ce.png";